<script setup lang="ts">
  import type { Component } from 'vue';
  import NoHomologations from '@/shared/assets/images/no-homologations.svg';
  import { IconImage } from '@/shared/ui';

  interface Props {
    title: string;
    description?: string;
    icon?: string | Component;
  }

  const props = withDefaults(defineProps<Props>(), {
    description: undefined,
    icon: NoHomologations,
  });
</script>

<template>
  <div class="flex flex-col items-center justify-center mt-[60px]">
    <IconImage
      :src="props.icon"
      :alt="props.title"
    />
    <h3 class="text-xl font-semibold leading-[30px] text-center max-w-[404px] break-words">
      {{ props.title }}
    </h3>
    <p
      v-if="props.description"
      data-testid="no-documents-description"
      class="mt-2 text-sm text-gray-05 text-center max-w-[404px] break-words"
    >
      {{ props.description }}
    </p>
    <div
      v-if="$slots.default"
      class="mt-6"
      data-testid="no-documents-actions"
    >
      <slot />
    </div>
  </div>
</template>
